export function inputs() {
  focusHandler();
  customFileBtnHandler();
  //errorHandler();
  //submitHadler();
}

function focusHandler() {
  const inputs = document.querySelectorAll('input:not([type="hidden"], [type="submit"], [type="file"])');

  if (!inputs.length) return;

  inputs.forEach(input => {
    input.addEventListener('focus', addInputLabelClass);
    input.addEventListener('input', removeErrorLabelClass);
    input.addEventListener('blur', removeInputLabelClass);
  });
}

function removeErrorLabelClass(event) {
  const wrapper = event.target.closest('.form-input');
  if (wrapper) {
    wrapper.classList.remove('input--error');
  };

  const errorTip = wrapper?.querySelector('.wpcf7-not-valid-tip');
  console.log(errorTip);
  if (errorTip) {
    errorTip.style.display = 'none';
  }
  
}

function addInputLabelClass(event) {
  const label = event.target.closest('.form-input')?.querySelector('.input__label');
  if (!label) return;

  label.classList.add('input__label--active');
}

function removeInputLabelClass(event) {
  const label = event.target.closest('.form-input')?.querySelector('.input__label');
  if (!label) return;

  if (event.target.value === '') {
    label.classList.remove('input__label--active');
  }
}

function errorHandler() {
  document.addEventListener('wpcf7invalid', function(event) {
  const form = event.target;
  

  setTimeout(() => {
    form.querySelectorAll('.wpcf7-not-valid').forEach(function(field) {
    console.log('wpcf7invalid')
      const parent = field.closest('.form-input');
      if (parent) {
        parent.classList.add('input--error'); 
      }
    });
  });
  }, 100);

  document.addEventListener('wpcf7submit', function(event) {
    const form = event.target;

    // очищаємо попередні помилки
    form.querySelectorAll('.form-input.input--error').forEach(function(fieldWrapper) {
      fieldWrapper.classList.remove('input--error');
    });
  });
}

function submitHadler() {
  const customButton = document.querySelector('.js-custom-submit');

  customButton.addEventListener('click', function () {
    const form = customButton.closest('form.wpcf7-form');
    if (form) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });
}

function customFileBtnHandler(){
  const fileInput = document.querySelector('#user-file');
  const customFileButton = document.querySelector('.custom-file__btn');

  if (!fileInput || !customFileButton) return;

  customFileButton.addEventListener('click', () => {
    customFileButton.closest('.form-input__file').querySelector('input[type="file"]').click();
  });

  fileInput.addEventListener('change', function() {

    if (this.files && this.files.length > 0) {
      customFileButton.textContent = this.files[0].name; // показує назву файлу
    } else {
      customFileButton.textContent = 'Обрати файл'; // дефолтний текст
    }
  });
}